<template>
    <div class='income'>
        <!-- 顶部筛选区域 -->
        <div class="filter-section">
            <div class="filter-left">
                <!-- <div class="filter-item">
                    <el-select v-model="selectedAccount" placeholder="全部PD统计账号" clearable @change="handleAccountChange">
                        <el-option v-for="item in accountOptions" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </div> -->
                <div class="filter-item">
                    <el-date-picker v-model="startDate" type="date" placeholder="开始日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd" @change="handleDateChange">
                    </el-date-picker>
                </div>
                <div class="filter-item">
                    <el-date-picker v-model="endDate" type="date" placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd" @change="handleDateChange">
                    </el-date-picker>
                </div>
                <!-- <div class="filter-item">
                    <el-checkbox v-model="groupByDay" @change="handleGroupByDayChange">Group by day</el-checkbox>
                </div> -->
            </div>
            <div class="filter-right">
                <div class="filter-item">
                    <div class="total-display">总计: {{ totalAmount }}</div>
                    <el-button type="primary" @click="searchData">查看</el-button>
                    <el-button @click="resetFilter">重置</el-button>
                    <el-button type="success" @click="exportData">导出数据</el-button>
                    <el-button type="warning" @click="getTableData(true)" :loading="loading">
                        <i class="el-icon-refresh"></i> 刷新数据
                    </el-button>
                </div>
            </div>
        </div>

        <!-- 缓存状态提示 -->
        <div v-if="lastUpdateTime" class="cache-status">
            <el-alert 
                :title="`数据缓存状态: ${shouldUpdateData() ? '建议刷新' : '数据较新'}`"
                :type="shouldUpdateData() ? 'warning' : 'success'"
                :closable="false"
                show-icon>
                <template slot="default">
                    <span>最后更新: {{ formatLastUpdateTime() }}</span>
                    <el-button type="text" size="mini" @click="getTableData(true)" style="margin-left: 10px;">
                        立即刷新
                    </el-button>
                </template>
            </el-alert>
        </div>

        <!-- 数据表格 -->
        <div class="data-table">
            <el-table :data="tableData" style="width: 100%" v-loading="loading" border stripe 
                header-cell-class-name="table-header" :max-height="tableHeight">
                <el-table-column prop="member" label="Member" min-width="220" fixed="left">
                    <template slot-scope="scope">
                        <div class="member-info">
                            <div class="member-id">{{ scope.row.member.id }},{{ scope.row.member.name }},<span class="member-age">{{ scope.row.member.age }}</span></div>
                            <div class="member-email">{{ scope.row.member.email }}</div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="subtotal" label="小计" min-width="100" align="center">
                    <template slot-scope="scope">
                        <span class="subtotal-value">
                            {{ scope.row.subtotal }}
                            <span v-if="scope.row.subtotalIncreased" class="increase-arrow">↑</span>
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="chatMessages" label="消息" min-width="120" align="center">
                    <template slot-scope="scope">
                        <span>
                            {{ scope.row.chatMessages }}
                            <span v-if="scope.row.chatMessagesIncreased" class="increase-arrow">↑</span>
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="chatPhotoUploads" label="照片上传" min-width="140" align="center">
                    <template slot-scope="scope">
                        <span>
                            {{ scope.row.chatPhotoUploads }}
                            <span v-if="scope.row.chatPhotoUploadsIncreased" class="increase-arrow">↑</span>
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="chatVideoUploads" label="视频上传" min-width="140" align="center">
                    <template slot-scope="scope">
                        <span>
                            {{ scope.row.chatVideoUploads }}
                            <span v-if="scope.row.chatVideoUploadsIncreased" class="increase-arrow">↑</span>
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="chatPostRead" label="帖子阅读" min-width="130" align="center">
                    <template slot-scope="scope">
                        <span>
                            {{ scope.row.chatPostRead }}
                            <span v-if="scope.row.chatPostReadIncreased" class="increase-arrow">↑</span>
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="chatAudioUploads" label="音频上传" min-width="140" align="center">
                    <template slot-scope="scope">
                        <span>
                            {{ scope.row.chatAudioUploads }}
                            <span v-if="scope.row.chatAudioUploadsIncreased" class="increase-arrow">↑</span>
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="photoComments" label="照片评论" min-width="130" align="center">
                    <template slot-scope="scope">
                        <span>
                            {{ scope.row.photoComments }}
                            <span v-if="scope.row.photoCommentsIncreased" class="increase-arrow">↑</span>
                        </span>
                    </template>
                </el-table-column>
                <!-- <el-table-column prop="winks" label="Winks" width="100" align="center"></el-table-column> -->
                <el-table-column prop="stickers" label="贴纸" min-width="120" align="center">
                    <template slot-scope="scope">
                        <span>
                            {{ scope.row.stickers }}
                            <span v-if="scope.row.stickersIncreased" class="increase-arrow">↑</span>
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="correspondence" label="信件" min-width="120" align="center">
                    <template slot-scope="scope">
                        <span>
                            {{ scope.row.correspondence }}
                            <span v-if="scope.row.correspondenceIncreased" class="increase-arrow">↑</span>
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="correspondenceAttachments" label="信件附件" min-width="140" align="center">
                    <template slot-scope="scope">
                        <span>
                            {{ scope.row.correspondenceAttachments }}
                            <span v-if="scope.row.correspondenceAttachmentsIncreased" class="increase-arrow">↑</span>
                        </span>
                    </template>
                </el-table-column>
                <!-- <el-table-column prop="stream" label="Stream" width="100" align="center"></el-table-column> -->
                <!-- <el-table-column prop="videoStream" label="Video stream" width="130" align="center"></el-table-column>
                <el-table-column prop="videoIntro" label="Video intro" width="130" align="center"></el-table-column>
                <el-table-column prop="donation" label="Donation" width="100" align="center"></el-table-column> -->
                <el-table-column prop="virtualGift" label="虚拟礼物" min-width="130" align="center">
                    <template slot-scope="scope">
                        <span>
                            {{ scope.row.virtualGift }}
                            <span v-if="scope.row.virtualGiftIncreased" class="increase-arrow">↑</span>
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="mailAttachmentVideo" label="邮件视频" min-width="140" align="center">
                    <template slot-scope="scope">
                        <span>
                            {{ scope.row.mailAttachmentVideo }}
                            <span v-if="scope.row.mailAttachmentVideoIncreased" class="increase-arrow">↑</span>
                        </span>
                    </template>
                </el-table-column>
                <!-- <el-table-column prop="moderatorCredits" label="Moderator credits" width="150" align="center"></el-table-column> -->
                <!-- <el-table-column prop="competitionVote" label="Competition vote" width="150" align="center"></el-table-column> -->
                <el-table-column prop="readMail" label="阅读邮件" min-width="130" align="center">
                    <template slot-scope="scope">
                        <span>
                            {{ scope.row.readMail }}
                            <span v-if="scope.row.readMailIncreased" class="increase-arrow">↑</span>
                        </span>
                    </template>
                </el-table-column>
                <!-- <el-table-column prop="finesCompensation" label="Fines compensation" width="150" align="center"></el-table-column>
                <el-table-column prop="fineNoVideoVerification" label="Fine no video verification" width="200" align="center"></el-table-column>
                <el-table-column prop="realPresentApproved" label="Real present approved" width="170" align="center"></el-table-column>
                <el-table-column prop="realPresentFailed" label="Real present failed" width="170" align="center"></el-table-column>
                <el-table-column prop="videoCall" label="Video call" width="120" align="center"></el-table-column>
                <el-table-column prop="contestVotes" label="Contest votes" width="130" align="center"></el-table-column> -->
            </el-table>
        </div>

        <!-- 分页 -->
        <div class="pagination">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import dayjs from 'dayjs'
import { getTrustedUsers, getStatisticByTypeAgency } from '@/api/talkytimes/income'

export default {
    components: {},
    data() {
        return {
            // 数据提醒显示状态
            showDataTip: true,

            // 筛选条件
            startDate: dayjs().format('YYYY-MM-DD'),
            endDate: dayjs().format('YYYY-MM-DD'),
            groupByDay: false, // 默认不按天分组

            // 表格数据
            tableData: [],
            allData: [], // 缓存所有数据用于分页和导出
            previousData: [], // 缓存上一次的数据用于比较
            loading: false,

            // 分页
            currentPage: 1,
            pageSize: 10,
            total: 0,

            // 表格高度
            tableHeight: 800,

            // 数据保活相关
            dataCacheKey: 'incomePageData',
            stateCacheKey: 'incomePageState',
            cacheExpireTime: 30 * 60 * 1000, // 30分钟过期
            lastUpdateTime: null
        };
    },
    computed: {
        // 计算总计金额
        totalAmount() {
            if (!this.allData || this.allData.length === 0) {
                return '0.00';
            }
            
            const total = this.allData.reduce((sum, item) => {
                return sum + parseFloat(item.subtotal || 0);
            }, 0);
            
            return total.toFixed(2);
        }
    },
    watch: {},
    methods: {
        // 初始化默认日期
        initDefaultDates() {
            const today = dayjs().format('YYYY-MM-DD');
            this.startDate = today;
            this.endDate = today;
        },
        // 获取表格数据
        async getTableData(forceRefresh = false) {
            // 如果不强制刷新，先尝试从缓存恢复
            if (!forceRefresh && this.restorePageData()) {
                console.log('使用缓存数据，跳过API请求');
                return;
            }

            this.loading = true;

            try {
                // 构建请求参数
                const params = {
                    dateFrom: this.startDate || '',
                    dateTo: this.endDate || '',
                    groupByDate: this.groupByDay ? 1 : 0,
                    idTrustedUser: null,
                    types: []
                };

                const response = await getStatisticByTypeAgency(params);
                
                if (response.code === 200 && response.data) {
                    // 转换数据格式
                    const newData = this.transformApiData(response.data);
                    
                    // 比较新旧数据，标记增长的项目
                    const processedData = this.compareAndMarkChanges(newData);
                    
                    // 更新数据
                    this.previousData = newData; // 保存当前数据作为下次比较的基准
                    this.allData = processedData;
                    this.total = this.allData.length;
                    this.lastUpdateTime = Date.now();
                    
                    // 前端分页处理
                    this.updateTableData();
                    
                    // 保存数据到缓存
                    this.savePageData();
                } else {
                    this.$message.error(response.msg || '获取数据失败');
                    this.tableData = [];
                    this.total = 0;
                }
            } catch (error) {
                console.error('获取数据失败:', error);
                this.$message.error('获取数据失败');
                this.tableData = [];
                this.total = 0;
            } finally {
                this.loading = false;
            }
        },

        // 比较新旧数据并标记变化
        compareAndMarkChanges(newData) {
            if (!this.previousData || this.previousData.length === 0) {
                // 第一次加载数据，没有比较基准
                return newData.map(item => this.addIncreaseFlags(item, false));
            }

            return newData.map(newItem => {
                // 查找对应的旧数据
                const oldItem = this.previousData.find(old => old.id === newItem.id);
                
                if (!oldItem) {
                    // 新用户，没有比较基准
                    return this.addIncreaseFlags(newItem, false);
                }

                // 比较各项数据
                const increaseFlags = {
                    subtotalIncreased: parseFloat(newItem.subtotal) > parseFloat(oldItem.subtotal),
                    chatMessagesIncreased: parseFloat(newItem.chatMessages) > parseFloat(oldItem.chatMessages),
                    chatPhotoUploadsIncreased: parseFloat(newItem.chatPhotoUploads) > parseFloat(oldItem.chatPhotoUploads),
                    chatVideoUploadsIncreased: parseFloat(newItem.chatVideoUploads) > parseFloat(oldItem.chatVideoUploads),
                    chatPostReadIncreased: parseFloat(newItem.chatPostRead) > parseFloat(oldItem.chatPostRead),
                    chatAudioUploadsIncreased: parseFloat(newItem.chatAudioUploads) > parseFloat(oldItem.chatAudioUploads),
                    photoCommentsIncreased: parseFloat(newItem.photoComments) > parseFloat(oldItem.photoComments),
                    stickersIncreased: parseFloat(newItem.stickers) > parseFloat(oldItem.stickers),
                    correspondenceIncreased: parseFloat(newItem.correspondence) > parseFloat(oldItem.correspondence),
                    correspondenceAttachmentsIncreased: parseFloat(newItem.correspondenceAttachments) > parseFloat(oldItem.correspondenceAttachments),
                    virtualGiftIncreased: parseFloat(newItem.virtualGift) > parseFloat(oldItem.virtualGift),
                    mailAttachmentVideoIncreased: parseFloat(newItem.mailAttachmentVideo) > parseFloat(oldItem.mailAttachmentVideo),
                    readMailIncreased: parseFloat(newItem.readMail) > parseFloat(oldItem.readMail)
                };

                return this.addIncreaseFlags(newItem, increaseFlags);
            });
        },

        // 为数据项添加增长标记
        addIncreaseFlags(item, increaseFlags) {
            if (typeof increaseFlags === 'boolean') {
                // 如果是布尔值，表示所有字段都不增长
                return {
                    ...item,
                    subtotalIncreased: false,
                    chatMessagesIncreased: false,
                    chatPhotoUploadsIncreased: false,
                    chatVideoUploadsIncreased: false,
                    chatPostReadIncreased: false,
                    chatAudioUploadsIncreased: false,
                    photoCommentsIncreased: false,
                    stickersIncreased: false,
                    correspondenceIncreased: false,
                    correspondenceAttachmentsIncreased: false,
                    virtualGiftIncreased: false,
                    mailAttachmentVideoIncreased: false,
                    readMailIncreased: false
                };
            }

            return {
                ...item,
                ...increaseFlags
            };
        },

        // 转换API数据格式
        transformApiData(apiData) {
            return apiData.map(item => {
                const bonusesList = item.bonusesList || {};
                
                // 解析用户信息
                const userInfo = this.parseUserInfo(item.trustedUser);
                
                // 计算小计
                const subtotal = parseFloat(item.bonuses || 0).toFixed(2);
                
                return {
                    id: item.idTrustedUser,
                    member: {
                        id: item.idTrustedUser,
                        name: userInfo.name,
                        age: userInfo.age,
                        email: '' // 新接口没有邮箱字段，暂时留空
                    },
                    subtotal: subtotal,
                    chatMessages: (bonusesList.chat_message || 0).toFixed(2),
                    chatPhotoUploads: (bonusesList.chat_photo || 0).toFixed(2),
                    chatVideoUploads: (bonusesList.chat_video || 0).toFixed(2),
                    chatPostRead: (bonusesList.chat_post_read || 0).toFixed(2),
                    chatAudioUploads: (bonusesList.chat_audio || 0).toFixed(2),
                    photoComments: (bonusesList.chat_comment || 0).toFixed(2),
                    winks: (bonusesList.chat_wink || 0).toFixed(2),
                    stickers: (bonusesList.chat_sticker || 0).toFixed(2),
                    correspondence: (bonusesList.correspondence_female_send || 0).toFixed(2),
                    correspondenceAttachments: (bonusesList.correspondence_watch_attachment || 0).toFixed(2),
                    stream: (bonusesList.stream_watch || 0).toFixed(2),
                    videoStream: (bonusesList.video_stream || 0).toFixed(2),
                    videoIntro: (bonusesList.video_intro || 0).toFixed(2),
                    donation: (bonusesList.donation || 0).toFixed(2),
                    virtualGift: (bonusesList.virtual_gift || 0).toFixed(2),
                    mailAttachmentVideo: (bonusesList.mail_attachment_video || 0).toFixed(2),
                    moderatorCredits: (bonusesList.acs_moderator_credits || 0).toFixed(2),
                    competitionVote: (bonusesList.competition_vote || 0).toFixed(2),
                    readMail: (bonusesList.read_mail || 0).toFixed(2),
                    finesCompensation: (bonusesList.fines_compensation || 0).toFixed(2),
                    fineNoVideoVerification: (bonusesList.fine_no_video_verification || 0).toFixed(2),
                    realPresentApproved: (bonusesList.real_present_approved || 0).toFixed(2),
                    realPresentFailed: (bonusesList.real_present_failed || 0).toFixed(2),
                    videoCall: (bonusesList.video_call || 0).toFixed(2),
                    contestVotes: (bonusesList.contest_vote || 0).toFixed(2)
                };
            });
        },

        // 解析用户信息
        parseUserInfo(trustedUser) {
            if (!trustedUser) {
                return { name: '', age: '' };
            }
            
            // 格式: "Dan, 33" 或 "Xiang Ping, 43"
            const parts = trustedUser.split(',');
            if (parts.length >= 2) {
                const name = parts[0].trim();
                const age = parts[1].trim();
                return { name, age };
            }
            
            return { name: trustedUser, age: '' };
        },



        // 更新表格数据（分页）
        updateTableData() {
            const startIndex = (this.currentPage - 1) * this.pageSize;
            const endIndex = startIndex + this.pageSize;
            this.tableData = this.allData.slice(startIndex, endIndex);
        },
        // 日期筛选变化
        handleDateChange() {
            console.log('日期筛选变化:', this.startDate, this.endDate);
            this.currentPage = 1;
            this.savePageState(); // 保存状态
            this.getTableData(true); // 强制刷新数据
        },

        // 按天分组变化
        handleGroupByDayChange() {
            console.log('按天分组变化:', this.groupByDay);
            this.currentPage = 1;
            this.savePageState(); // 保存状态
            this.getTableData(true); // 强制刷新数据
        },

        // 查询数据
        searchData() {
            this.currentPage = 1;
            this.savePageState(); // 保存状态
            this.getTableData(true); // 强制刷新数据
        },

        // 重置筛选
        resetFilter() {
            this.initDefaultDates();
            this.groupByDay = false; // 重置为默认值
            this.currentPage = 1;
            this.clearAllCache(); // 清除缓存
            this.savePageState(); // 保存状态
            this.getTableData(true); // 强制刷新数据
        },

        // 分页大小变化
        handleSizeChange(size) {
            this.pageSize = size;
            this.currentPage = 1;
            this.savePageState(); // 保存状态
            this.updateTableData();
        },

        // 页码变化
        handleCurrentChange(page) {
            this.currentPage = page;
            this.savePageState(); // 保存状态
            this.updateTableData();
        },

        // 导出数据
        exportData() {
            this.$message.info('正在导出数据...');

            try {
                // 创建CSV格式的数据
                const csvContent = this.generateCSVContent();
                const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
                const downloadUrl = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = downloadUrl;
                link.download = `统计数据_${dayjs().format('YYYY-MM-DD')}.csv`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(downloadUrl);
                this.$message.success('数据导出成功');
            } catch (error) {
                console.error('导出数据失败:', error);
                this.$message.error('导出数据失败');
            }
        },

        // 生成CSV内容
        generateCSVContent() {
            let csvContent = '\uFEFFMember ID,Member Name,Member Age,小计,Chat messages,Chat photo uploads,Chat video uploads,Chat post read,Chat audio uploads,Photo comments,Winks,Stickers,Correspondence,Correspondence attachments,Stream,Video stream,Video intro,Donation,Virtual gift,Mail attachment video,Moderator credits,Competition vote,Read mail,Fines compensation,Fine no video verification,Real present approved,Real present failed,Video call,Contest votes\n';

            // 使用所有数据（不仅仅是当前页）
            this.allData.forEach(item => {
                csvContent += `${item.member.id},${item.member.name},${item.member.age},${item.subtotal},${item.chatMessages},${item.chatPhotoUploads},${item.chatVideoUploads},${item.chatPostRead},${item.chatAudioUploads},${item.photoComments},${item.winks},${item.stickers},${item.correspondence},${item.correspondenceAttachments},${item.stream},${item.videoStream},${item.videoIntro},${item.donation},${item.virtualGift},${item.mailAttachmentVideo},${item.moderatorCredits},${item.competitionVote},${item.readMail},${item.finesCompensation},${item.fineNoVideoVerification},${item.realPresentApproved},${item.realPresentFailed},${item.videoCall},${item.contestVotes}\n`;
            });

            return csvContent;
        },

        // 隐藏数据提醒
        hideDataTip() {
            this.showDataTip = false;
        },

        // 计算表格高度
        calculateTableHeight() {
            const windowHeight = window.innerHeight;
            this.tableHeight = windowHeight - 100; // 进一步减少减去的高度，让表格占用更多空间
        },

        // ==================== 数据保活相关方法 ====================
        
        // 保存页面数据到缓存
        savePageData() {
            try {
                // 检查是否正在退出登录，如果是则不保存数据
                const token = localStorage.getItem('Admin-Token');
                if (!token) {
                    console.log('检测到退出登录，跳过保存页面数据');
                    return;
                }
                
                const cacheData = {
                    allData: this.allData,
                    previousData: this.previousData,
                    lastUpdateTime: Date.now(),
                    timestamp: Date.now()
                };
                localStorage.setItem(this.dataCacheKey, JSON.stringify(cacheData));
                console.log('页面数据已保存到缓存');
            } catch (error) {
                console.error('保存页面数据失败:', error);
            }
        },

        // 从缓存恢复页面数据
        restorePageData() {
            try {
                // 检查是否已登录，如果没有登录则不恢复缓存数据
                const token = localStorage.getItem('Admin-Token');
                if (!token) {
                    console.log('未登录状态，跳过恢复缓存数据');
                    return false;
                }
                
                const cachedData = localStorage.getItem(this.dataCacheKey);
                if (!cachedData) {
                    return false;
                }

                const parsedData = JSON.parse(cachedData);
                
                // 检查缓存是否过期
                if (Date.now() - parsedData.timestamp > this.cacheExpireTime) {
                    localStorage.removeItem(this.dataCacheKey);
                    console.log('缓存数据已过期，已清除');
                    return false;
                }

                // 恢复数据
                this.allData = parsedData.allData || [];
                this.previousData = parsedData.previousData || [];
                this.lastUpdateTime = parsedData.lastUpdateTime;
                this.total = this.allData.length;
                
                // 更新表格显示
                this.updateTableData();
                
                console.log('页面数据已从缓存恢复');
                return true;
            } catch (error) {
                console.error('恢复页面数据失败:', error);
                localStorage.removeItem(this.dataCacheKey);
                return false;
            }
        },

        // 保存页面状态到缓存
        savePageState() {
            try {
                // 检查是否正在退出登录，如果是则不保存状态
                const token = localStorage.getItem('Admin-Token');
                if (!token) {
                    console.log('检测到退出登录，跳过保存页面状态');
                    return;
                }
                
                const state = {
                    startDate: this.startDate,
                    endDate: this.endDate,
                    groupByDay: this.groupByDay,
                    currentPage: this.currentPage,
                    pageSize: this.pageSize,
                    timestamp: Date.now()
                };
                sessionStorage.setItem(this.stateCacheKey, JSON.stringify(state));
                console.log('页面状态已保存');
            } catch (error) {
                console.error('保存页面状态失败:', error);
            }
        },

        // 从缓存恢复页面状态
        restorePageState() {
            try {
                // 检查是否已登录，如果没有登录则不恢复缓存状态
                const token = localStorage.getItem('Admin-Token');
                if (!token) {
                    console.log('未登录状态，跳过恢复缓存状态');
                    return false;
                }
                
                const savedState = sessionStorage.getItem(this.stateCacheKey);
                if (!savedState) {
                    return false;
                }

                const state = JSON.parse(savedState);
                
                // 检查状态是否过期（超过30分钟）
                if (Date.now() - state.timestamp > this.cacheExpireTime) {
                    sessionStorage.removeItem(this.stateCacheKey);
                    return false;
                }

                // 恢复状态
                this.startDate = state.startDate || dayjs().format('YYYY-MM-DD');
                this.endDate = state.endDate || dayjs().format('YYYY-MM-DD');
                this.groupByDay = state.groupByDay || false;
                this.currentPage = state.currentPage || 1;
                this.pageSize = state.pageSize || 10;
                
                console.log('页面状态已恢复');
                return true;
            } catch (error) {
                console.error('恢复页面状态失败:', error);
                sessionStorage.removeItem(this.stateCacheKey);
                return false;
            }
        },

        // 清除所有缓存
        clearAllCache() {
            localStorage.removeItem(this.dataCacheKey);
            sessionStorage.removeItem(this.stateCacheKey);
            console.log('收入页面缓存已清除');
        },

        // 清空页面数据
        clearPageData() {
            this.allData = [];
            this.previousData = [];
            this.tableData = [];
            this.total = 0;
            this.lastUpdateTime = null;
            this.currentPage = 1;
            console.log('页面数据已清空');
        },

        // 检查数据是否需要更新
        shouldUpdateData() {
            if (!this.lastUpdateTime) {
                return true;
            }
            
            // 如果数据超过5分钟，建议更新
            const fiveMinutes = 5 * 60 * 1000;
            return Date.now() - this.lastUpdateTime > fiveMinutes;
        },

        // 格式化最后更新时间
        formatLastUpdateTime() {
            if (!this.lastUpdateTime) {
                return '未知';
            }
            
            const now = Date.now();
            const diff = now - this.lastUpdateTime;
            const minutes = Math.floor(diff / (1000 * 60));
            
            if (minutes < 1) {
                return '刚刚';
            } else if (minutes < 60) {
                return `${minutes}分钟前`;
            } else {
                const hours = Math.floor(minutes / 60);
                return `${hours}小时前`;
            }
        }
    },
    created() {
        // 检查登录状态
        const token = localStorage.getItem('Admin-Token');
        if (!token) {
            console.log('未登录状态，清空页面数据');
            this.clearPageData();
            this.initDefaultDates();
            return;
        }
        
        // 先恢复页面状态
        this.restorePageState();
        
        // 如果没有恢复状态，则初始化默认日期
        if (!this.startDate || !this.endDate) {
            this.initDefaultDates();
        }
        
        // 获取数据（会尝试从缓存恢复）
        this.getTableData();
    },
    mounted() {
        this.calculateTableHeight();
        window.addEventListener('resize', this.calculateTableHeight);
        
        // 添加页面离开前的事件监听
        window.addEventListener('beforeunload', this.savePageState);
        window.addEventListener('pagehide', this.savePageState);
    },
    beforeDestroy() {
        // 保存页面状态和数据
        this.savePageState();
        this.savePageData();
        
        // 移除事件监听
        window.removeEventListener('resize', this.calculateTableHeight);
        window.removeEventListener('beforeunload', this.savePageState);
        window.removeEventListener('pagehide', this.savePageState);
    },
    // 添加路由离开守卫
    beforeRouteLeave(to, from, next) {
        // 保存页面状态和数据
        this.savePageState();
        this.savePageData();
        next();
    },
}
</script>

<style lang='scss' scoped>
.income {
    padding: 10px;
    background-color: #f5f5f5;
    min-height: calc(100vh - 64px);

    .filter-section {
        background: white;
        padding: 15px;
        border-radius: 8px;
        margin-bottom: 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

        .filter-left {
            display: flex;
            align-items: center;
            gap: 15px;
        }

        .filter-right {
            display: flex;
            align-items: center;
        }

        .filter-item {
            display: flex;
            align-items: center;
            gap: 10px;

            .total-display {
                font-size: 16px;
                font-weight: bold;
                color: #333;
                margin-left: 15px;
                padding: 8px 12px;
                background: #f0f9ff;
                border: 1px solid #e1f5fe;
                border-radius: 4px;
            }
        }
    }

    .cache-status {
        margin-bottom: 10px;
        
        .el-alert {
            border-radius: 8px;
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        }
    }

    .data-table {
        background: white;
        padding: 10px;
        border-radius: 8px;
        margin-bottom: 10px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        overflow-x: auto;
        width: 100%;

        .member-info {
            display: flex;
            flex-direction: column;
            gap: 2px;

            .member-id {
                font-weight: bold;
                color: #333;
                font-size: 12px;
            }

            .member-name {
                color: #666;
                font-size: 13px;
            }

            .member-age {
                display: inline-block;
                background: #67C23A;
                color: white;
                padding: 2px 6px;
                border-radius: 4px;
                font-size: 12px;
                width: fit-content;
            }

            .member-email {
                color: #999;
                font-size: 12px;
                word-break: break-all;
            }
        }

        .subtotal-value {
            background: #F56C6C;
            color: white;
            padding: 2px 6px;
            border-radius: 4px;
            font-weight: bold;
            font-size: 12px;
        }

        .increase-arrow {
            color: #F56C6C;
            font-weight: bold;
            margin-left: 2px;
            font-size: 12px;
        }

        // 表格标题样式
        ::v-deep .table-header {
            background: #f8f9fa !important;
            font-weight: bold !important;
            font-size: 12px !important;
            color: #333 !important;
            text-align: center !important;
            white-space: nowrap !important;
            padding: 8px 4px !important;
        }

        // 斑马条纹样式
        ::v-deep .el-table--striped .el-table__body tr.el-table__row--striped td {
            background: #f5f6f7;
        }

        // 完全禁用表格hover效果
        ::v-deep .el-table__body tr:hover>td {
            background-color: transparent !important;
        }

        ::v-deep .el-table--striped .el-table__body tr:hover>td {
            background-color: #f5f6f7 !important;
        }

        // 固定列样式
        ::v-deep .el-table__fixed {
            box-shadow: 2px 0 8px rgba(0, 0, 0, 0.1);
        }

        // 表格内容居中对齐
        ::v-deep .el-table td {
            text-align: center;
            font-size: 12px;
            padding: 6px 4px !important;
        }

        // 数字列样式
        ::v-deep .el-table td {
            color: #666;
        }

        // 确保表格铺满容器
        ::v-deep .el-table {
            width: 100% !important;
        }

        ::v-deep .el-table__body-wrapper {
            width: 100% !important;
        }
    }

    .pagination {
        display: flex;
        justify-content: center;
        background: white;
        padding: 10px;
        border-radius: 8px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    }
}
</style>